import { tailwindVariables } from '../../styles/tailwindVariables';
import chroma from 'chroma-js';

export let TITANIC_HEIGHT = 260;
export let SCENE_OVERLAP = 40;

let base = chroma(tailwindVariables.theme.colors.purple[900]);

export let underwaterLight = base.set('lch.l', 35).hex();

export let terrainBgColor = base.set('lch.l', 50).hex();
export let terrainMgColor = base.set('lch.l', 25).hex();
export let terrainFgColor = base.set('lch.l', 10).hex();

export let hullLight = base.set('lch.l', 62).hex();
export let hullMid = base.set('lch.l', 30).hex();
export let hullFineDetail = terrainFgColor;

export let getDrift = (speed: number) => Math.round(TITANIC_HEIGHT * (1 - speed));

export let layers = {
  bgGradient: { speed: 0.3, zIndex: 0 },
  terrainBg: { speed: 0.4, zIndex: 1 },
  terrainMg: { speed: 0.5, zIndex: 2 },
  ship: { speed: 0.5, zIndex: 3 },
  terrainFg: { speed: 0.7, zIndex: 10 },
} as const;
